




















































































































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { getModule } from 'vuex-module-decorators';
import Decisions from "@/store/modules/Decisions";
import Navigation from '@/store/modules/Navigation';
import * as rules from '@/rules';
import { Auth } from "aws-amplify";

//@ts-ignore
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth/lib-esm/Auth";
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Urls } from "@/Urls";
import Apps from "@/store/modules/Apps";
import _ from "lodash";
import vuetify from '@/plugins/vuetify';

const decisionsModule = getModule(Decisions);
const navigationModule = getModule(Navigation);
const appsModule = getModule(Apps);

@Component({
    components: {}
})
export default class Login extends Vue {
    private readonly Urls = Urls;

    @Prop()
    error!: string;

    @Prop({default: false, type: Boolean})
    oneClick!: boolean;

    @Prop()
    queryDecisionId!: string;

    @Prop()
    queryPasscode!: string;

    @Prop({ default: false, type: Boolean })
    isPopup!: boolean;

    @Ref()
    private formRef: HTMLFormElement;

    @Ref()
    private emailAddress: HTMLInputElement;

    private rules = {
        required: rules.REQUIRED,
        emailFormat: rules.EMAIL_FORMAT
    }


    private signingIn = false;
    private showPassword = false;
    private username = '';
    private password = '';
    private usernameErrorMessage: string | null = null;

    mounted() {
        if (this.queryDecisionId && this.queryPasscode){
            Vue.$cookies.set('joinDecision', {
                decisionId: this.queryDecisionId,
                passcode: this.queryPasscode
            })
        }
        if (this.error && this.error.includes('PreSignUp')) {
            this.$router.push({path: Urls.SIGNUP, query: this.$router.currentRoute.query})
        }
        const emailAddressRef = this.emailAddress;
        // console.log('emailAddressRef');
        // console.log(emailAddressRef);
        emailAddressRef.focus();
        // setTimeout( ()=>( emailAddressRef.focus(), 200) );
    }

    private socialSignIn(provider: CognitoHostedUIIdentityProvider) {
        Auth.federatedSignIn({provider: provider})
    }

    private async login() {
        if (!this.formRef.validate()) {
            return;
        }
        this.signingIn = true;
        try {
            const user = await Auth.signIn(this.username.trim().toLowerCase(), this.password.trim());
            // console.log('user');
            // console.log(user);
            let status = navigationModule.anonUserId;
            // console.log('status');
            console.log(user);
            const unAuthUserId = user.attributes.profile || '';
            const authUserId = user.attributes.sub || '';
            if (unAuthUserId && authUserId) {
                try {
                    let res: any = await VIEWPOINT_API.updateOwnership(unAuthUserId, authUserId);
                    // console.log('VIEWPOINT_API.updateOwnership(unauthUserId, signUpResult.userSub)');
                    // console.log(res);
                    await decisionsModule.fetchDecisions();
                } catch (error){
                    console.log(error);
                }
            }
            AmplifyEventBus.$emit('authState', 'signedIn');
            // if user clicked subcribe button before login, take them to the payment location
            if (this.$cookies.isKey('app-subscribe')){
                let itemId = _.clone(this.$cookies.get('app-subscribe'));
                this.$cookies.remove('app-subscribe');
                await appsModule.fetchMarketplaceItems();
                let location: any = {
                    path: Urls.CHECKOUT,
                    query: {
                        product: itemId,
                        successUrl: window.location.origin + Urls.TEMPLATES + '?session_id={CHECKOUT_SESSION_ID}',
                        cancelUrl: window.location.origin + Urls.MARKETPLACE
                    }
                }
                this.$router.push(location);
                return;
            } else if (this.$cookies.isKey('app-add')) {
                // if user click the add button on template, after login, add user to the template
                let itemId = this.$cookies.get('app-add');0
                this.$cookies.remove('app-add');
                await appsModule.fetchMarketplaceItems();
                await appsModule.addUserToApp({
                    id: itemId,
                    userId: authUserId,
                });
                this.$router.push({
                    name: 'Marketplace',
                })
                return;
            } 
            if (this.isPopup) {
                this.$router.push({
                        name: 'Marketplace',
                    })
                this.$emit('loggedIn');
                return
            } else {
                // kathy - if user has saved cookie for app-share-url 
                //         user will be taken to the app-share-url after login
                if(Vue.$cookies.isKey('joinDecision')){
                    const urlCookies = Vue.$cookies.get('joinDecision');
                    let urlPath = 
                        `${Urls.JOIN_DECISION}?passcode=${urlCookies.passcode}&decisionId=${urlCookies.decisionId}`;
                    Vue.$cookies.remove('joinDecision');
                    this.$router.push(urlPath);
                    return;
                }
                if(Vue.$cookies.isKey('app-share-url')){
                    let url = Vue.$cookies.get('app-share-url');
                    Vue.$cookies.remove('app-share-url');
                    // console.log('push to new url');
                    this.$router.push(url);
                    return;
                }
                // if user has saved cookie for app-clone-url
                // user will be taken to the Decision cloning process
                if(Vue.$cookies.isKey('app-clone-url')){
                    let url = Vue.$cookies.get('app-clone-url');
                    Vue.$cookies.remove('app-clone-url');
                    this.$router.push(url);
                    return;
                }

            }
                
        } catch (error) {
            console.log(error);
            if (error.code) {
                if (error.code === 'UserNotConfirmedException') {
                    await Auth.resendSignUp(this.username.toLowerCase())
                    this.usernameErrorMessage = "Account has not been confirmed, confirmation email has been resent."
                } else if (error.code === 'PasswordResetRequiredException') {
                    await this.$router.push(Urls.RESET_PASSWORD);
                } else if (error.code === 'NotAuthorizedException') {
                    this.password = '';
                    this.usernameErrorMessage = 'Username and/or password is incorrect'
                }
            }
        }
        this.signingIn = false;
    }
}
